import { graphql } from '../../gql';

export const SKILL_TAXONOMY_SECONDARY_SELECTION_LIST_QUERY = graphql(`
  query SkillTaxonomySecondarySelectionList(
    $taxonomy_id: Int!
    $l0: Int!
    $l1: Int!
    $l2: Int!
    $l3: Int!
    $l4: Int!
  ) {
    selectionList {
      skill_0: skill_taxonomy(
        taxonomy_select: { taxonomy_id: $taxonomy_id, level_id: $l0 }
      ) {
        tax_id
        tax_name
        tax_version
        refs {
          id
          short_name
          long_name
          titles
          parents
        }
        label {
          level_id
          tag
          label
        }
      }

      skill_1: skill_taxonomy(
        taxonomy_select: { taxonomy_id: $taxonomy_id, level_id: $l1 }
      ) {
        tax_id
        tax_name
        tax_version
        refs {
          id
          short_name
          long_name
          titles
          parents
        }
        label {
          level_id
          tag
          label
        }
      }

      skill_2: skill_taxonomy(
        taxonomy_select: { taxonomy_id: $taxonomy_id, level_id: $l2 }
      ) {
        tax_id
        tax_name
        tax_version
        refs {
          id
          short_name
          long_name
          titles
          parents
        }
        label {
          level_id
          tag
          label
        }
      }
      skill_3: skill_taxonomy(
        taxonomy_select: { taxonomy_id: $taxonomy_id, level_id: $l3 }
      ) {
        tax_id
        tax_name
        tax_version
        refs {
          id
          short_name
          long_name
          titles
          parents
        }
        label {
          level_id
          tag
          label
        }
      }

      skill_4: skill_taxonomy(
        taxonomy_select: { taxonomy_id: $taxonomy_id, level_id: $l4 }
      ) {
        tax_id
        tax_name
        tax_version
        refs {
          id
          short_name
          long_name
          titles
          parents
        }
        label {
          level_id
          tag
          label
        }
      }
    }
  }
`);
